module.exports = __webpack_public_path__ + "img/dynamic_big.86738e50.png";